
import FormValidation from "../FormValidate";

export default class {

    constructor() 
    {
 
        this.form = document.getElementById('form-llamanos');
        this.form.addEventListener('submit',this,false);
        this.btn = document.getElementById('btn-form-llamamos');
       

       
    }

    handleEvent(evt)
    {
        evt.preventDefault();

        this.VF = new FormValidation('form-llamanos','#form-llamanos',true);

        console.log( this.VF);

        if(  this.VF.validForm !== true )
        {
            console.log("epa");
            return false;
        }


        this.btn.disabled = true;
        this.btn.textContent = 'Enviando...';

        this.registerData('dataAgenda');


        var request = new XMLHttpRequest();
        
        request.open("POST", petrobras.url ,false);
        request.send(this.dataAgenda);

 

        if ( request.readyState === 4)
        {
            if( request.status == 200)
            {
                let result = JSON.parse( request.responseText );
                console.log(result);
                document.getElementById('result-contact').textContent = result.msg;
                console.log( request )
            }
        }

        this.btn.disabled = false;
        this.btn.textContent = 'Enviar';

        return false;
    }

    registerData(  storage ) {
        this[storage] = new FormData(document.getElementById('form-llamanos'));
    }

    obtainForm(pointer){
        let data = [];
    
        for( var pair of this[pointer].entries() )
        {
          let index = pair[0];
          let value = pair[1];
          data.push( [index,value] );
        }
    
        return data;
    }

}